module.exports = __webpack_public_path__ + "static/media/flower.37dcd0cd.png";